import React, { useEffect, useState } from "react";
import "./Dropdown.scss";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import { ReactComponent as Search } from "../../../assets/svg/search.svg";

function Dropdown(props: any) {
  const {
    label,
    menuItems,
    name,
    placeholder,
    dropdownSearchInputPlaceHolder,
    selectedValue,
    required,
    disabled,
    searchable,
    errorMsg,
    onClearClick,
    isLoading,
    onChange,
    isFieldTouched,
  } = props;
  const [value, setValue] = useState(selectedValue || "");
  const [dropDownValue, setDropDownValue] = useState(selectedValue || "");
  const [focused, setFocused] = useState<boolean>(false);
  useEffect(() => {
    if (props?.clearValue) {
      setValue(null);
      setDropDownValue(null);
    }
  }, [props?.clearValue]);
  return (
    <div className="input-group">
      {label && (
        <label>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div
        className={`input-dropdown-control w-100 ${
          disabled && "dropdown-disabled"
        } ${errorMsg && "error"}`}
      >
        {searchable ? (
          <Autocomplete
            options={menuItems}
            noOptionsText={"No Data to display"}
            //placeholder={dropdownSearchInputPlaceHolder}
            getOptionLabel={(option: any) => option.displayValue || ""}
            value={dropDownValue || " "}
            onInputChange={(event, newInputValue) => {
              props.onInputChange(event, newInputValue);
            }}
            onChange={(event, newValue) => {
              onChange && props?.onChange(newValue);
              setDropDownValue(newValue);
              if (newValue === null && onClearClick) {
                onClearClick();
              }
            }}
            forcePopupIcon={false}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={dropdownSearchInputPlaceHolder}
                fullWidth
                value={dropDownValue}
                disabled={disabled}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        ) : (
          <TextField
            select
            sx={{
              margin: "0 !important",
              ".MuiSelect-outlined": {
                maxHeight: "4rem !important",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "10px !important",
                color: "#0d0d0d",
              },
              ".MuiFormLabel-root": {
                lineHeight: "12px",
              },
            }}
            name={name}
            required={required}
            margin="normal"
            value={value}
            onChange={(value) => {
              if (props.onChange) {
                props?.onChange(value.target.value);
              }
              setValue(value.target.value);
            }}
            onFocus={() => {
              setFocused(true);
            }}
            onBlur={() => {
              setFocused(false);
              isFieldTouched();
            }}
            fullWidth
            disabled={disabled}
            label={value || focused ? "" : placeholder}
          >
            {menuItems &&
              menuItems?.length > 0 &&
              menuItems?.map((menuItem: any) => (
                <MenuItem key={menuItem?.value} value={menuItem?.value}>
                  {menuItem?.displayValue}
                </MenuItem>
              ))}
          </TextField>
        )}
      </div>
      {errorMsg && (
        <div className="error-message">
          <span className="custom-error-message">{label} is required</span>
        </div>
      )}
    </div>
  );
}

export default Dropdown;
